export const GLOBAL_EVENTS = Object.freeze({
   PROPERTY_DETAILS: {
       DISCUSSION_CLICK: 'PropertyDetails:discussion-click',
       FILES_CLICK: 'PropertyDetails:files-click',
   },
    HOMEOWNER_SEARCHED_PROPERTIES: 'homeowner-searched-properties',
});
